import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MapaGeolocalizacionComponent } from "./mapa-geolocalizacion.component";

@NgModule({
    declarations: [MapaGeolocalizacionComponent],
    imports: [
        CommonModule,
        MatDialogModule,
        MatIconModule,
        MatButtonModule,
        MatProgressSpinnerModule,
    ],
    exports: [MapaGeolocalizacionComponent]
})
export class MapaGeolocalizacionModule {}
